// src/components/TypingIndicator.js - VERSÃO FINAL CORRIGIDA

import React from "react";
import styles from "./TypingIndicator.module.css";

export default function TypingIndicator() {
  return (
    // CORREÇÃO: Usando parênteses retos para a classe principal
    <div className={styles['typing-indicator']}>
      
      {/* CORREÇÃO: Usando parênteses retos para as classes dos pontos */}
      <span className={`${styles.dot} ${styles.dot1}`}></span>
      <span className={`${styles.dot} ${styles.dot2}`}></span>
      <span className={`${styles.dot} ${styles.dot3}`}></span>

    </div>
  );
}